<div [ngClass]="customClasses" [ngStyle]="{ width: width, height: height, borderRadius: borderRadius }"
  class="shadow-lg ">
  <ng-content></ng-content>
</div>